import { allValuesForApiField } from "../common/services/Filters";

// Formatting information on aggregate reports
export const reports: any = {
  failures: {
    by_state: {
      agg_by: "PSTALP",
      agg_term_fields: ["RESTYPE"],
      agg_sum_fields: ["QBFASSET", "QBFDEP", "COST"],
      subtotal_by: null,
      total_fields: null,
    },
    by_year: {
      agg_by: "FAILYR",
      agg_term_fields: ["RESTYPE", "SAVR", "CHCLASS1", "RESTYPE1"],
      agg_sum_fields: [],
      subtotal_by: null,
      total_fields: null,
    },
    detail: {
      agg_by: null,
      agg_term_fields: null,
      agg_sum_fields: null,
      subtotal_by: "RESTYPE",
      total_fields: ["QBFDEP", "QBFASSET", "COST"],
    },
  },
};

export const reportColumnData = (
  reportFamily: string,
  reportName: string,
  colMeta: any,
) => {
  // generate the aggregation-style field names (fields) and corresponding col metadata (cols)
  // based on the report config above and the state 'columns' meta data passed in
  const reportMeta = reports[reportFamily][reportName];
  const fields: string[] = [];
  const cols: any = {};
  // agg_by field
  fields.push(reportMeta.agg_by);
  fields.push("count");
  cols[reportMeta.agg_by] = colMeta[reportMeta.agg_by];
  cols["count"] = { title: "Total Count", type: "integer" };
  // term fields are split out into count_COLNAME['VALUE'] format
  reportMeta.agg_term_fields.forEach((fieldName: any) => {
    const vals = allValuesForApiField(fieldName);
    vals.forEach((val: string) => {
      const newName = `count_${fieldName}_${val}`;
      fields.push(newName);
      if (colMeta[fieldName]) {
        cols[newName] = { ...colMeta[fieldName] };
        cols[newName].title = `${colMeta[fieldName].title}: ${val}`;
        cols[newName].type = "integer";
      } else {
        cols[newName] = { title: newName, type: "string" };
      }
    });
  });
  // sum fields are sum_COLNAME format
  reportMeta.agg_sum_fields.forEach((fieldName: any) => {
    const newName = `sum_${fieldName}`;
    fields.push(newName);
    cols[newName] = { ...colMeta[fieldName] };
    cols[newName].title = `${colMeta[fieldName].title}`;
  });
  return [fields, cols];
};

export function spellOutState(input: string) {
  const lookup: { [key: string]: string } = {
    AZ: "Arizona",
    AL: "Alabama",
    AK: "Alaska",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AS: "American Samoa",
    GU: "Guam",
    MP: "Northern Mariana Islands",
    PR: "Puerto Rico",
    VI: "Virgin Islands",
    UM: "U.S. Minor Outlying Islands",
  };
  return lookup[input];
}
